import { render, staticRenderFns } from "./FormControlColorPicker.vue?vue&type=template&id=3eb40420&"
import script from "./FormControlColorPicker.vue?vue&type=script&lang=js&"
export * from "./FormControlColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports